import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { getRoomTimetable, getStaffTimetable, getStudentTimetable } from "./api";

export type StudentTimetableFetchParams = {
    studentNo: number;
    censusDate?: string;
}

export const studentTimetableQueryOptions = (params: StudentTimetableFetchParams ) =>
    queryOptions({
        queryKey: ['timetable', 'student', params],
        queryFn: () => getStudentTimetable(params.studentNo, { censusDate: params.censusDate }),
    })

export function useStudentTimetable(params: StudentTimetableFetchParams) {
    return useQuery(studentTimetableQueryOptions(params))
}

export function useStudentTimetableSuspense(params: StudentTimetableFetchParams) {
    return useSuspenseQuery(studentTimetableQueryOptions(params))
}

export type StaffTimetableFetchParams = {
    initials: string;
    censusDate?: string;
}

export const staffTimetableQueryOptions = (params: StaffTimetableFetchParams ) =>
    queryOptions({
        queryKey: ['timetable', 'staff', params],
        queryFn: () => getStaffTimetable(params.initials, { censusDate: params.censusDate }),
    })

export function useStaffTimetable(params: StaffTimetableFetchParams) {
    return useQuery(staffTimetableQueryOptions(params))
}

export function useStaffTimetableSuspense(params: StaffTimetableFetchParams) {
    return useSuspenseQuery(staffTimetableQueryOptions(params))
}

export const roomTimetableQueryOptions = (params: { roomCode: string; censusDate?: string }) =>
    queryOptions({
        queryKey: ['timetable', 'room', params],
        queryFn: () => getRoomTimetable(params.roomCode, { censusDate: params.censusDate }),
    })

export function useRoomTimetable(params: { roomCode: string; censusDate?: string }) {
    return useQuery(roomTimetableQueryOptions(params))
}

export function useRoomTimetableSuspense(params: { roomCode: string; censusDate?: string }) {
    return useSuspenseQuery(roomTimetableQueryOptions(params))
}
